<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Venture Capital: why AUM is the wrong metric</h1>
                <span class="meta"> Posted in December 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/aumwrongmetric.png" alt="">
                </figure>
                
                <p>There's an old dig that venture capitalists like to make about private equity professionals: private equity folks boast about the size of their ego in AUM, whereas VCs know that what really matters is their IRR.</p>

                <p>Now let's define these three-letter words. First, I'm using the word ego as a euphemism here to be gender agnostic (albeit in reality it's usually only men who tend to make this brag). AUM means assets under management (i.e. the total amount of money in the funds managed by the general partner team). IRR means internal rate of return (i.e. the cash returns distributed to a fund’s investors, annualized).</p>

                <p>Asset managers care about AUM because it directly translates into guaranteed revenue. Closed-end investment funds typically follow a “2 and 20 model,” meaning annual management fees of 2% and a share of 20% of the capital gains generated by the fund (aka carried interest). The annual management fees are a direct function of AUM, i.e. 2% of total AUM each year. They are contractually established for the life of the fund, usually 10 years. The carried interest is a direct function of fund performance, i.e. 20% of the capital gains generated by the fund.</p>

                <p>Accordingly, a large AUM directly translates into a significant guaranteed revenue stream for the entire life of the fund. A fund manager with $1 billion in AUM is probably receiving around $20 million per year in recurring revenue. A micro VC fund of say $10 million is receiving only $200k per year in recurring revenue via its management fees.</p>

                <h2 class="section-heading">Risk of misalignment</h2>
                
                <p>Since management fees are meant to cover the operations of the fund, excessively high management fees can translate into high salaries for the managing partners, luxurious offices, and lavish parties. Even if the fund’s financial performance is lackluster, a guaranteed annual revenue stream in the double-digit millions for several years makes for a fairly comfortable lifestyle. Do you see where a potential misalignment can emerge?</p>

                <p>In contrast, a small VC fund can afford no such excesses. The managers of a small VC fund cannot become wealthy on management fees alone. They must perform. Only by generating significant capital gains on the funds they manage will they be able to generate wealth for themselves via the carried interest mechanism. IRR represents each fund’s financial performance.</p>

                <p>For LP investors in private equity or VC funds who care about financial return, IRR is the metric that reflects their financial return, not AUM. So I submit that when a fund manager brags about their AUM, the appropriate rebuttal would be to ask their IRR.</p>

                <p>Full disclosure: I too used to be guilty of the AUM flex. As a former GP in a fund that managed nearly $1 billion in AUM, I would often open my introduction at conferences by citing this figure. But over time, I learned that IRR represents my true KPI as a fund manager. IRR is the indicator of how well or how poorly I perform my job. It is not a mathematical anomaly that my best-performing funds have been those with smaller fund sizes, hence lower AUM.</p>

                <p>In many ways actually, a propensity to chatter more about AUM than IRR is an indication of the stage of an ecosystem. When the venture market in a given region is still nascent, track records are limited, so the nearest metric people can look for is assets under management. However, once a fund manager has progressed beyond their first vintage, the more the relevant question to ask is, “So what is your IRR ?”</p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
